import styled from 'styled-components';

export const TitleContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 1.5rem;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
`;

export const SubTitle = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  justify-content: flex-start;

  & > .hefesto-title {
    margin-bottom: 1.5rem;
  }
`;

export const SummaryContainer = styled.div`
  width: 97vw;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 0.25rem;
  padding: 0.7rem;
  margin: 1rem auto;
  display: flex;
  justify-content: flex-end;

  & > .hefesto-title {
    margin-bottom: 1.5rem;
  }
`;

export const SummaryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  margin: 1rem;
`;

export const SummaryContainerTitle = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  & > div {
    padding-right: 4.5rem;
  }
`;

export const SummaryContainerCell = styled.div`
  display: flex;
  flex-grow: 0.5;
  justify-content: flex-end;

  & > div {
    padding-right: 4.5rem;
  }
`;

export const SummaryTableContainer = styled.div`
  width: 97vw;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 0.25rem;
  margin: 1rem auto;

  & > .hefesto-title {
    margin-bottom: 1.5rem;
  }
`;
